import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as SysByOxIconSVG } from './system-by-ox.svg';
import { ReactComponent as ConnectivityIssueSVG } from './connectivity-issue.svg';
import { ReactComponent as NotConnectedSVG } from './discovered-connector.svg';
import { Theme } from '@mui/material';
import {
  BadgeStatusType,
  BadgeProductionStageType,
  IconType,
} from '../BadgeIcon/badgeIcon.types';

const ConnectivityIcon: FC<React.PropsWithChildren<IconProps>> = ({ type }) => {
  const { classes, cx } = useStyles();
  switch (type) {
    case IconType.Connected:
      return null;
    case IconType.NotConnected:
      return <NotConnectedSVG data-testid={IconType.NotConnected} />;
    case IconType.ConnectionIssue:
      return <ConnectivityIssueSVG data-testid={IconType.ConnectionIssue} />;
    case IconType.SystemByOx:
      return <SysByOxIconSVG data-testid={IconType.SystemByOx} />;
    case IconType.ComingSoon:
      return (
        <div
          data-testid={IconType.ComingSoon}
          className={cx(classes.badgeText, classes.comingSoon)}>
          Coming Soon
        </div>
      );
    case IconType.Beta:
      return (
        <div data-testid={IconType.Beta} className={cx(classes.badgeText)}>
          Beta
        </div>
      );
    default:
      return null;
  }
};

export interface IconProps {
  type: IconType | BadgeStatusType | BadgeProductionStageType;
}

const useStyles = makeStyles()((theme: Theme) => ({
  comingSoon: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
  },
  badgeText: {
    lineHeight: 1.1,
    backgroundColor: theme.palette.badge.comingSoon,
    borderRadius: 2,
    padding: '0.185em',
  },
}));

export default ConnectivityIcon;
